import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { H1, P } from 'shared';
function PreQualificationDeclinedPage() {
    return (_jsx("div", { className: "declined-container", children: _jsxs("div", { className: "content", children: [_jsx(H1, { className: "first-title", children: "Pre-qualification" }), _jsx(P, { className: "first-subtitle", variant: "title-large", bold: true, children: "Thank you for your interest." }), _jsx(P, { bold: true, children: "We were unable to pre-qualify you. " })] }) }));
}
export default PreQualificationDeclinedPage;
